import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { translate } from '@jsverse/transloco';

import { SimpleDialogButtonColor } from 'app/components/simple-dialog.component';
import { AuthService } from 'app/providers/bridge-api/auth.service';
import { DashboardService } from 'app/providers/bridge-api/dashboard.service';
import { AlertService } from 'app/services/alert.service';
import { DialogService } from 'app/services/dialog.service';
import { EnableClassTelemetry } from 'app/services/otel.service';
import { DashboardDetailsComponent } from '../pages/dashboard-details/dashboard-details.component';

@EnableClassTelemetry()
@Injectable()
export class CanDeactivateDashboardViewService {
  constructor(
    private dialogService: DialogService,
    private authService: AuthService,
    private alertService: AlertService,
    private dashboardService: DashboardService,
    private router: Router
  ) {}

  canDeactivate(component: DashboardDetailsComponent): Promise<boolean> {
    return new Promise((resolve) => {
      if (
        this.authService.isLoggedIn() &&
        component.dashboardViewComponent.isDashboardNew &&
        component.dashboardViewComponent.isUnsaved
      ) {
        this.dialogService
          .showSimpleDialog({
            title: translate('dashboard-view.label.unsaved-changes-dialog'),
            content: translate('dashboard-view.text.unsaved-dashboard-dialog'),
            confirmTitle:
              !this.router.getCurrentNavigation()?.extras?.state?.hideSave &&
              translate('dashboard-view.label.save-now'),
            confirmColor: SimpleDialogButtonColor.blue,
            cancelTitle: translate('simple-dialog.cancel'),
            buttons: [
              {
                title: translate('dashboard-view.label.continue-without-save'),
                color: SimpleDialogButtonColor.orange,
                handler: (dialogRef) => {
                  dialogRef.close();
                  this.authService.getSession().then((session) => {
                    this.dashboardService.removeCachedDashboard(
                      component.dashboardViewComponent.dashboardId,
                      component.dashboardViewComponent.projectId,
                      session.info2.user_id
                    );

                    this.alertService.showToast(
                      translate('dashboard-view.alert.deleting-dashboard', {
                        dashboardName: component.dashboardViewComponent.dashboard.title,
                      })
                    );

                    resolve(true);
                  });
                },
              },
            ],
          })
          .afterClosed()
          .subscribe(async (result) => {
            if (result) {
              component.dashboardViewComponent
                .saveDashboard({ skipNavigation: true })
                .then(() => resolve(true));
            }
          });
      } else {
        resolve(true);
      }
    });
  }
}
